import { Controller } from "@hotwired/stimulus"

const formatter = new Intl.NumberFormat("ja-JP")

export default class extends Controller {
  static targets = ["value"]
  static values = {
    value: Number,
    duration: { type: Number, default: 1600 }
  }

  connect() {
    this.animationFrame = null

    if (!this.hasValueTarget || !Number.isFinite(this.valueValue)) return
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      this.render(this.valueValue)
      return
    }

    this.animate()
  }

  disconnect() {
    if (this.animationFrame) window.cancelAnimationFrame(this.animationFrame)
  }

  animate() {
    const endValue = Math.max(0, Math.round(this.valueValue))
    const distance = Math.min(Math.max(Math.round(endValue * 0.08), 800), 50_000)
    const startValue = Math.max(0, endValue - distance)
    const startedAt = window.performance.now()

    this.render(startValue)

    const step = (timestamp) => {
      const progress = Math.min((timestamp - startedAt) / this.durationValue, 1)
      const easedProgress = 1 - Math.pow(1 - progress, 3)
      const currentValue = Math.round(startValue + (endValue - startValue) * easedProgress)

      this.render(currentValue)

      if (progress < 1) {
        this.animationFrame = window.requestAnimationFrame(step)
      } else {
        this.animationFrame = null
      }
    }

    this.animationFrame = window.requestAnimationFrame(step)
  }

  render(value) {
    this.valueTarget.textContent = formatter.format(value)
  }
}
